import { Flex, Grid, Text, type BoxProps } from '@/ui';
import { Shape } from './Shape';

type Props = {
  label?: string;
  squareCols?: number;
  squareRows?: number;
  shapeProps?: BoxProps;
};

const Square = ({ ...props }: BoxProps) => (
  <Shape {...props} height={props.height ?? '12px'} w="100%" />
);

export const GridIcon = ({
  label,
  squareCols = 2,
  squareRows = 2,
  shapeProps = {},
}: Props) => {
  return (
    <Flex flexDir="column" gap="2px" w="70%">
      {label && (
        <Text
          color="gray.700"
          fontSize="10px"
          fontWeight="bold"
          mb="1px"
          textAlign="left"
        >
          {label}
        </Text>
      )}
      <Grid
        gap="2px"
        gridTemplateColumns={`repeat(${squareCols}, 1fr)`}
        w="100%"
      >
        {Array.from({ length: squareRows * squareCols }).map((_, index) => (
          <Square {...shapeProps} key={index} />
        ))}
      </Grid>
    </Flex>
  );
};
